import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-charts/themeAugmentation';

import { capitalCategoricalPalette } from '../../capitalCategoricalPalette';

export const MuiBarChart: ThemeOptions['components']['MuiBarChart'] = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
